import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export const storageKey = {
  accessToken: 'access_token',
  refreshToken: 'refresh_token',
  email: 'email',
  userId: 'userId',
  roleId: 'roleId',
  isAdmin: 'isAdmin',
  isMSUser: 'isMSUser',
  isActive: 'isActive',
  isAssignAllProject: 'isAssignAllProject',
  keepMeLogin: 'keepMeLogin',
  profile: 'profile',
};

export const env_notify = {
  type: {
    Success: 'success' as const,
    Error: 'error' as const,
    Warning: 'warning' as const,
    Info: 'info' as const,
  },
};

export const invoiceStatus = {
  Draft: 'Draft',
  InProgress: 'InProgress',
  Challenged: 'Challenged',
  SignedOff: 'SignedOff',
  FasterPayment: 'FasterPayment',
  CreditCard: 'CreditCard',
  AccountPayment: 'AccountPayment',
  CreditNote: 'CreditNote',
  DirectDebit: 'DirectDebit',
};

@Injectable({ providedIn: 'root' })
export class ConsoleService {
  log(...args: any[]): void {
    if (!environment.consoleOff) {
      console.log(...args);
    }
  }

  error(...args: any[]): void {
    if (!environment.consoleOff) {
      console.error(...args);
    }
  }

  warn(...args: any[]): void {
    if (!environment.consoleOff) {
      console.warn(...args);
    }
  }
}
